<template>
  <div :el="mods">
    <slot></slot>
  </div>
</template>

<script>
import { check } from "./verify";
const name = "btn";
export default {
  props: ["el"],
  computed: {
    mods() {
      return this.el ? `${name}-${this.el}` : name;
    },
  },
  watch: {
    el(val) {
      check(name, val);
    },
  },
  mounted() {
    check(name, this.el);
  },
};
</script>
